import { jsx as _jsx } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Chevron } from "@faire/web--source/slate/icons/foundation/Chevron";
import { Row } from "@faire/web--source/slate/Layout";
import React from "react";
import styled, { css } from "styled-components";
import { ACCORDION_TRANSITION_TIMING } from "./utils";
export var ChevronIcon = function(param) {
    var isAccordionOpen = param.isAccordionOpen;
    return /*#__PURE__*/ _jsx(ChevronRow, {
        align: "flex-start",
        children: /*#__PURE__*/ _jsx(AnimatedChevron, {
            $isAccordionOpen: isAccordionOpen,
            children: /*#__PURE__*/ _jsx(Chevron, {
                "data-test-id": "accordion-chevron",
                direction: "right",
                fontSize: "16px",
                color: Core.icon.default
            })
        })
    });
};
var AnimatedChevron = styled.div.withConfig({
    componentId: "sc-dd1e43eb-0"
})([
    "transform:rotate( ",
    " );transition-property:transform;",
    ""
], function(param) {
    var $isAccordionOpen = param.$isAccordionOpen;
    return css([
        "",
        "deg"
    ], $isAccordionOpen ? -90 : 90);
}, ACCORDION_TRANSITION_TIMING);
var ChevronRow = styled(Row).withConfig({
    componentId: "sc-dd1e43eb-1"
})([
    "margin-left:auto;margin-right:0;"
]);
